import { VoyagersClubNoMembershipContainerProps } from '@msc-b2c/interfaces/types';
import { VoyagersClubNoMembershipContainer } from './VoyagersClubNoMembershipContainer';
import { RootState } from '@msc-b2c/shared-utils';
import { useSelector } from 'react-redux';

export function VoyagersClubNoMembershipContainerWrapper({
  headerTitle,
  description,
  readMore,
  readLess,
  children,
}: Readonly<VoyagersClubNoMembershipContainerProps>) {
  const properties: VoyagersClubNoMembershipContainerProps = {
    headerTitle,
    description,
    readMore,
    readLess,
    children,
  };

  const membershipData = useSelector((state: RootState) => state.myCruise.membershipData);
  const membershipDataIsLoading = useSelector(
    (state: RootState) => state.myCruise.membershipDataIsLoading
  );

  if (
    !membershipDataIsLoading &&
    (membershipData?.memberships === undefined ||
      (membershipData?.memberships !== undefined && membershipData?.memberships?.length === 0))
  ) {
    return <VoyagersClubNoMembershipContainer {...properties} />;
  }

  return null;
}

VoyagersClubNoMembershipContainerWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/voyagersclubnomembershipcontainer';

export default VoyagersClubNoMembershipContainerWrapper;
